import React from "react";
import { InvoiceUsedTable } from "../Tables";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";
import { toast } from "react-hot-toast";
import { invoicesData } from "../Datas";

function InvoiceUsed({ patientId }) {
  const navigate = useNavigate();
  const [invoices, setInvoices] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  // Fetch invoices for patient
  React.useEffect(() => {
    const fetchInvoices = async () => {
      if (!patientId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        // Note: You may need to adjust this endpoint based on your backend API
        // This is a placeholder - check if there's a patient-specific invoice endpoint
        const response = await axios.get(`${BaseUrl}/doctor/invoices`, {
          withCredentials: true,
          params: { patientId },
        });

        if (response.data?.data && Array.isArray(response.data.data)) {
          // Filter invoices by patientId if backend doesn't filter
          const filteredInvoices = response.data.data.filter(
            (invoice) => invoice.patientId === patientId || invoice.patient?._id === patientId
          );
          setInvoices(filteredInvoices);
        } else if (Array.isArray(response.data)) {
          const filteredInvoices = response.data.filter(
            (invoice) => invoice.patientId === patientId || invoice.patient?._id === patientId
          );
          setInvoices(filteredInvoices);
        } else {
          setInvoices([]);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error);
        // Don't show error if it's just no invoices found
        if (error.response?.status !== 404) {
          toast.error(error.response?.data?.message || "Failed to load invoices");
        }
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [patientId]);

  // preview
  const preview = (id) => {
    navigate(`/invoices/preview/${id}`);
  };

  return (
    <div className='w-full'>
      <h1 className='mb-6 text-sm font-medium'>Invoices</h1>
      {loading ? (
        <div className='flex items-center justify-center py-10'>
          <p className='text-textGray'>Loading invoices...</p>
        </div>
      ) : (
        <div className='w-full overflow-x-scroll'>
          <InvoiceUsedTable
            data={invoices.length > 0 ? invoices : invoicesData}
            functions={{
              preview: preview,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default InvoiceUsed;
